import React from 'react';
import '@/styles/ipe/workbench/components/TaskProgressBar.css';

/**
 * @param {{ percent?: number, label?: string, detail?: string, indeterminate?: boolean, size?: 'sm'|'md', className?: string }} props
 */
export default function TaskProgressBar({
  percent = 0,
  label = '',
  detail = '',
  indeterminate = false,
  size = 'sm',
  className = '',
}) {
  const safePercent = indeterminate ? undefined : Math.max(0, Math.min(100, Number(percent) || 0));

  return (
    <div
      className={`funding-task-progress funding-task-progress--${size}${indeterminate ? ' funding-task-progress--indeterminate' : ''}${className ? ` ${className}` : ''}`}
    >
      {(label || !indeterminate) && (
        <div className="funding-task-progress__meta">
          {label ? <span className="funding-task-progress__label">{label}</span> : null}
          {!indeterminate && safePercent !== undefined ? (
            <span className="funding-task-progress__pct">{safePercent}%</span>
          ) : null}
        </div>
      )}
      <div
        className="funding-task-progress__track"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={indeterminate ? undefined : safePercent}
        aria-label={label || '任务进度'}
      >
        <div
          className="funding-task-progress__fill"
          style={indeterminate ? undefined : { width: `${safePercent}%` }}
        />
      </div>
      {detail ? <span className="funding-task-progress__detail">{detail}</span> : null}
    </div>
  );
}
